// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
var lastScrollTop = 0;

// Selectors
var HEADER_SELECTOR = '#shopify-section-header';
var PRODUCT_SECTION = '#shopify-section-product';

// Classes
var STICKY_CLASS = 'is-sticky';

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('scroll', function () {
  var productSection = document.querySelector(PRODUCT_SECTION);
  if (productSection === null) {
    var headerSection = document.querySelector(HEADER_SELECTOR);
    var noScrollBody = document.querySelector('body.noscroll');
    var st = document.documentElement.scrollTop;
    if (st > lastScrollTop || st == 0) {
      // If scrolling down
      headerSection.classList.remove(STICKY_CLASS);

      // Re-position the regular header
      if (noScrollBody) {
        // if on mobile and when the menu is open.
        headerSection.style.top = 0;
      } else {
        headerSection.style.top = '-500px';
      }
    } else if (st < lastScrollTop) {
      // If scrolling up
      headerSection.classList.add(STICKY_CLASS);
      headerSection.style.top = 0;
    }
    lastScrollTop = st <= 0 ? 0 : st;
  }
});